import React from 'react';
import PropTypes from 'prop-types';

import {black500} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

Title.propTypes = {
    children: PropTypes.node,
};

function Title(props) {
    const isMobile = UserAgentUtils.isMobile();

    return (
        <div style={{
            fontWeight: isMobile ? 700 : 600,
            color: black500,
            fontSize: isMobile ? '15px' : "20px",
            lineHeight: 'normal'
        }}>
            {props.children}
        </div>
    );
}

export default Title;
